import { useEffect } from 'react';
import './Contact.css';
import { CONTACT_EMAIL } from '../../config';
import SEOHead from '../../components/SEOHead';
import { SEO_CONFIG, getCanonicalUrl } from '../../config/seo';

function Contact() {

  useEffect(() => {
    document.title = 'Contact | Phoenix Unity Designs';
  }, []);

  return (
    <>
      <SEOHead
        title={SEO_CONFIG.contact.title}
        description={SEO_CONFIG.contact.description}
        keywords={SEO_CONFIG.contact.keywords}
        canonical={getCanonicalUrl(SEO_CONFIG.contact.path)}
        ogUrl={getCanonicalUrl(SEO_CONFIG.contact.path)}
      />
      <main id="main-content" tabIndex="-1" className='Contact page-container'>
      <div className='container mb-5'>
        <div className='row'>
          <div className='col'>
            <h1>Contact</h1>
            <p>Know what you want? Reach out!</p>
            <p>Still trying to figure out what you want? We can help! 🤝</p>
            <p><a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a></p>
            {/* <p><a href="tel:6131234567">(613)123-4567</a></p> */}
            <p>Ottawa, ON</p>
          </div>
        </div>
      </div>
    </main>
    </>
  );
}

export default Contact;
